import { CatalogItemPriceBase } from "@common/types/catalogItem";
import { getCurrentActivePriceForCurrency } from "./catalogItemPrice";
import { monetaryValuesEqual } from "./monetary";

interface CatalogItemMatchCandidate {
    name: string;
    active: boolean;
    prices?: CatalogItemPriceBase[];
}

interface CatalogItemMatchLine {
    item: string | null;
    description: string | null;
    unitAmount: number | null;
}

export function catalogItemLineName({
    item,
    description,
}: Pick<CatalogItemMatchLine, "item" | "description">): string {
    const itemName = item?.trim() ?? "";
    return itemName !== "" ? itemName : (description?.trim() ?? "");
}

export function catalogItemMatchesLine({
    item,
    line,
}: {
    item: CatalogItemMatchCandidate;
    line: CatalogItemMatchLine;
}): boolean {
    const lineName = catalogItemLineName(line).toLowerCase();
    const price = getCurrentActivePriceForCurrency(item.prices, "usd");
    return (
        item.active &&
        lineName !== "" &&
        item.name.trim().toLowerCase() === lineName &&
        (price === null ||
            (line.unitAmount !== null &&
                monetaryValuesEqual(price.unitAmount, line.unitAmount)))
    );
}
